import {
  AlertStatus,
  FlexColumn,
  FlexRow,
  formatDate,
  formatHash,
} from '@make-software/cspr-design';
import { Alert, BodyText, Tooltip } from '@block-explorer/ui';
import { Trans, useTranslation } from 'react-i18next';
import { buildRouterPath } from '../../../router/utils';
import {
  DELEGATE_STAKE_SIGN_PATH,
  MANAGE_ASSOCIATED_KEYS_SIGN_PATH,
  PURCHASE_NFT_SIGN_PATH,
  RouterPathsMap,
  TRANSFER_CSPR_SIGN_PATH,
  UNDELEGATE_STAKE_SIGN_PATH,
} from '../../../router/paths';
import React from 'react';
import CopyButton from '../../copy-button/copy-button';
import { DeployFlowType } from '../../../services';

const pathByDeployFlowTypeMap: Record<string, keyof RouterPathsMap> = {
  [DeployFlowType.transfer]: TRANSFER_CSPR_SIGN_PATH,
  [DeployFlowType.delegation]: DELEGATE_STAKE_SIGN_PATH,
  [DeployFlowType.undelegation]: UNDELEGATE_STAKE_SIGN_PATH,
  [DeployFlowType.purchaseNFT]: PURCHASE_NFT_SIGN_PATH,
  [DeployFlowType.manageAssociatedKeys]: MANAGE_ASSOCIATED_KEYS_SIGN_PATH,
};

interface SubmittedMultisigBlock {
  deployHash: string;
  deployFlowType: DeployFlowType;
}

export const SubmittedMultisigTransactionDetails = ({
  deployHash,
  deployFlowType,
}: SubmittedMultisigBlock) => {
  const { t } = useTranslation();

  const titleHash =
    deployFlowType === DeployFlowType.transfer ? (
      <Trans t={t}>Transfer hash:</Trans>
    ) : (
      <>{t('Transaction Hash')}:</>
    );

  const path = pathByDeployFlowTypeMap[deployFlowType];

  const link =
    window.location.origin +
    buildRouterPath(path, { deploy_hash: deployHash }, undefined);

  return (
    <>
      <FlexColumn itemsSpacing={16}>
        <FlexRow justify="space-between">
          <FlexRow align="baseline" itemsSpacing={8}>
            <BodyText variation="darkGray" lineHeight={'sm'} size={3}>
              {titleHash}
            </BodyText>
            <FlexRow align="center" itemsSpacing={4}>
              <Tooltip tooltipContent={deployHash}>
                <BodyText size={3} monotype lineHeight={'sm'}>
                  {formatHash(deployHash)}
                </BodyText>
              </Tooltip>
              <CopyButton value={deployHash} />
            </FlexRow>
          </FlexRow>
        </FlexRow>
      </FlexColumn>
      <FlexColumn itemsSpacing={16}>
        <Alert
          title={
            <BodyText size={1}>
              <Trans t={t}>Successfully created</Trans>
            </BodyText>
          }
          message={
            <FlexColumn itemsSpacing={16}>
              <FlexColumn itemsSpacing={20}>
                <BodyText variation="black" size={3}>
                  {t(
                    ' Please copy this link and share it with the other parties to\n' +
                      '      add their signatures. The transaction will be automatically\n' +
                      '      submitted, once enough weight is obtained.'
                  )}
                </BodyText>
                <BodyText variation="black" size={3}>
                  {t('Transaction expires in 2 hours.')}
                </BodyText>
              </FlexColumn>
              <CopyButton value={link} label={t('Copy link')} />
            </FlexColumn>
          }
          status={AlertStatus.Success}
        />
      </FlexColumn>
    </>
  );
};
